module.exports = __webpack_public_path__ + "static/media/apartment7.1fcd8723.jpg";